import { TrainingTable } from './TrainingTable';

export const TrainingComponent = () => {
  return (
    <>
      <div className='simply-header margin-left-2 margin-bottom-1 margin-top-3'>
        <button className='simply-header__button button-primary font-h5-medium margin-right-1'>New Training</button>
        <h2 className='font-h2-medium'>Template training</h2>
      </div>
      <TrainingTable />
    </>
  );
};
